<template>
  <div class="roles-container">
    <el-button
      size="small"
      type="primary"
      icon="el-icon-plus"
      @click="handleNew()"
      >{{ $t("app.new") }}</el-button
    >
    <el-table :data="tableData" style="width: 100%" stripe>
      <el-table-column align="left" width="350px" :label="$t('app.operation')">
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="handleEdit(scope.$index, scope.row)"
            >{{ $t("app.edit") }}</el-button
          >
          <el-button
            size="small"
            type="success"
            @click="handleBind(scope.row)"
            >{{ $t("app.bindingPermissions") }}</el-button
          >
          <el-button
            size="small"
            type="warning"
            @click="handleBindOperationPermission(scope.row)"
            >{{ $t("app.operationPermission") }}</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="handleDelete(scope.$index, scope.row)"
            >{{ $t("app.delete") }}</el-button
          >
        </template>
      </el-table-column>

      <template v-for="col in column">
        <el-table-column
          :key="col.model"
          align="center"
          :label="col.label"
          :prop="col.model"
        >
          <template slot-scope="scope">
            <template v-if="col.model === 'enable'">
              <div>
                <el-switch
                  v-model="scope.row.enable"
                  @change="roleEnable(scope.row, scope.row.enable)"
                >
                </el-switch>
              </div>
            </template>
            <template v-else>
              {{ scope.row[col.model] }}
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
    <role-edit
      ref="roleEdit"
      @handleSuccess="updateRole"
      @handleAdd="addRole"
    ></role-edit>
    <permission ref="permission"></permission>
    <operation-permission ref="operationpermission"></operation-permission>
  </div>
</template>

<script>
import RoleEdit from "./modules/RoleEdit";
import Permission from "./modules/Permission";
import {
  getRoleList,
  deleteRole,
  enableRole,
} from "@/api/systemManagement/roleManagement";
import OperationPermission from "./modules/OperationPermission.vue";
export default {
  components: {
    RoleEdit,
    Permission,
    OperationPermission,
  },
  data() {
    return {
      column: [
        { label: this.$t("app.roleCoding"), model: "code" },
        { label: this.$t("app.roleName"), model: "name" },
        { label: this.$t("app.enable"), model: "enable" },
      ],
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    getList() {
      getRoleList({ PageIndex: this.currentPage, PageSize: this.size }).then(
        (res) => {
          this.total = res.data.Total;
          this.tableData = res.data.Items.map((item) => {
            return {
              enable: item.IsUse,
              code: item.RoleCode,
              name: item.RoleName,
            };
          });
        }
      );
    },
    handleNew() {
      this.$refs.roleEdit.new();
    },
    handleEdit(index, row) {
      this.$refs.roleEdit.edit(index, row);
    },
    handleDelete(index, row) {
      this.$confirm(this.$t("app.isDelete") + "?(" + row.name + ")").then(
        () => {
          deleteRole({ RoleCode: row.code }).then(() => {
            this.tableData.splice(index, 1);
            this.$notify({
              title: this.$t("app.success"),
              message: this.$t("app.opeSuccess"),
              type: "success",
            });
          });
        }
      );
    },
    handleBind(row) {
      this.$refs.permission.edit(row);
    },
    handleBindOperationPermission(row) {
      this.$refs.operationpermission.edit(row);
    },
    roleEnable(row, val) {
      enableRole({ IsUse: val, RoleCode: row.code })
        .then(() => {
          this.$notify({
            title: this.$t("app.success"),
            message: this.$t("app.opeSuccess"),
            type: "success",
          });
        })
        .catch(() => {
          row.enable = !val;
        });
    },
    updateRole(index, obj) {
      this.tableData.splice(index, 1, obj);
    },
    addRole(obj) {
      this.tableData.push(obj);
    },
  },
};
</script>
<style lang="scss" scoped>
.roles-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
}
</style>
